<template lang="pug">
v-form.report-user-creation-form(ref="form")
  v-container
    base-text-divider 基本資料
    v-layout(wrap)
      v-flex(
        xs12
        sm4)
        v-text-field(
          v-model="displayName"
          :error-messages="displayNameErrors"
          :counter="4"
          label="姓名*"
          outline
          @input="$v.displayName.$touch()"
          @blur="$v.displayName.$touch()")
      v-flex(
        xs12
        sm4)
        v-select(
          v-model="region"
          :items="regionItems"
          :error-messages="regionErrors"
          item-value="value"
          item-text="text"
          label="所屬地區*"
          outline
          @input="$v.region.$touch()"
          @blur="$v.region.$touch()")
      v-flex(
        xs12
        sm4)
        v-text-field(
          v-model="phoneNumber"
          :counter="10"
          :error-messages="phoneNumberErrors"
          label="電話*"
          outline
          @input="$v.phoneNumber.$touch()"
          @blur="$v.phoneNumber.$touch()")
    base-text-divider 繳費項目
    receipt-item-fieldset(ref="itemFieldset")
    base-text-divider 收據資料
    v-layout(wrap)
      v-flex(xs12)            
        v-checkbox(
          v-model="needPaper"
          label="是否需寄送紙本收據")
    base-text-divider 轉帳資訊
    v-layout(wrap)
      v-flex(
        xs12
        sm4)
        v-select(
          v-model="method"
          :items="methodItems"
          :error-messages="methodErrors"
          item-value="value"
          item-text="text"
          label="付款方式*"
          outline
          @input="$v.method.$touch()"
          @blur="$v.method.$touch()")
      v-flex(
        v-if="method === 'transfer'"
        xs12
        sm4)
        v-text-field(
          v-model="lastFiveNumber"
          :error-messages="lastFiveNumberErrors"
          :counter="5"
          label="轉帳帳號後5碼*"
          outline
          @input="$v.lastFiveNumber.$touch()"
          @blur="$v.lastFiveNumber.$touch()")
      v-flex(
        v-if="method === 'bank_transfer'"
        xs12
        sm4)
        v-text-field(
          v-model="bankname"
          :error-messages="banknameErrors"
          label="匯款銀行名稱*"
          outline
          @input="$v.bankname.$touch()"
          @blur="$v.bankname.$touch()")
      v-flex(
        xs12
        sm4)
        v-menu(
          ref="transferDateMenu"
          v-model="transferDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="transferDateValue"
          lazy
          offset-y
          full-width
          min-width="290px")
          template(v-slot:activator="{ on }")
            v-text-field(
              v-model="transferDateValue"
              :error-messages="transferDateErrors"
              label="付款日期"
              readonly
              outline
              v-on="on")
          v-date-picker(
            v-model="transferDateValue"
            ref="transferDatePicker"
            locale="zh-TW"
            min="1900-1-1"
            :max="new Date().toISOString().substr(0, 10)"
            no-title
            scrollable
            @change="savetransferDate")
            v-spacer
            v-btn(
              flat
              color="error"
              @click="transferDateMenu = false") 取消
    form-actions(
      :loading="formMixin_loading"
      @cancel="$emit('cancel')"
      @submit="submit") {{ formMixin_message }}
</template>
<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  maxLength,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import { formMixin } from "@/mixins";
import { length, ref } from "@/utils/validators";
import ReceiptItemFieldset from "@/components/core/ReceiptItemFieldset.vue";
//
import REGIONS from "@/assets/tables/regions.json";
import PAYMENT_METHODS from "@/assets/tables/payment_methods.json";

export default {
  name: "ReportUserCreationForm",
  mixins: [validationMixin, formMixin],
  components: {
    ReceiptItemFieldset
  },
  validations: {
    displayName: { required, maxLength: maxLength(4) },
    phoneNumber: { required, numeric, maxLength: maxLength(10) },
    items: { required },
    region: { required },
    method: { required },
    lastFiveNumber: {
      required: ref("method", (value, ref) =>
        ref === "transfer" ? required(value) : true
      ),
      length: length(5),
      numeric
    },
    bankname: {
      required: ref("method", (value, ref) =>
        ref === "bank_transfer" ? required(value) : true
      )
    },
    transferDate: { required }
  },
  data() {
    return {
      regionItems: Object.entries(REGIONS).map(v => v[1]),
      methodItems: Object.entries(PAYMENT_METHODS).map(v => v[1]),
      transferDateMenu: false,
      displayName: null,
      region: null,
      phoneNumber: null,
      items: [],
      method: null,
      lastFiveNumber: null,
      bankname: null,
      transferDateValue: null,
      needPaper: false
    };
  },
  computed: {
    transferDate() {
      return this.transferDateValue ? new Date(this.transferDateValue) : "";
    },
    displayNameErrors() {
      const errors = [];
      if (!this.$v.displayName.$dirty) return errors;
      !this.$v.displayName.maxLength && errors.push("最多4個中文字");
      !this.$v.displayName.required && errors.push("必填姓名");
      return errors;
    },
    regionErrors() {
      const errors = [];
      if (!this.$v.region.$dirty) return errors;
      !this.$v.region.required && errors.push("必填所屬區域");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.phoneNumber.$dirty) return errors;
      !this.$v.phoneNumber.required && errors.push("請輸入電話");
      !this.$v.phoneNumber.numeric && errors.push("請輸入數字");
      !this.$v.phoneNumber.maxLength && errors.push("最多10個數字");
      return errors;
    },
    methodErrors() {
      const errors = [];
      if (!this.$v.method.$dirty) return errors;
      !this.$v.method.required && errors.push("請選擇付款方式");
      return errors;
    },
    lastFiveNumberErrors() {
      const errors = [];
      if (!this.$v.lastFiveNumber.$dirty) return errors;
      !this.$v.lastFiveNumber.required && errors.push("請輸入轉帳帳號後5碼");
      !this.$v.lastFiveNumber.length && errors.push("長度錯誤");
      !this.$v.lastFiveNumber.numeric && errors.push("請輸入數字");
      return errors;
    },
    banknameErrors() {
      const errors = [];
      if (!this.$v.bankname.$dirty) return errors;
      !this.$v.bankname.required && errors.push("請輸入匯款銀行名稱");
      return errors;
    },
    transferDateErrors() {
      const errors = [];
      if (!this.$v.transferDate.$dirty) return errors;
      !this.$v.transferDate.required && errors.push("請選擇付款日期");
      return errors;
    }
  },
  methods: {
    savetransferDate(date) {
      this.$refs.transferDateMenu.save(date);
    },
    async submit() {
      const items = this.$refs.itemFieldset.submit();
      if (!items) return false;

      this.items = items;

      const fields = [
        "displayName",
        "region",
        "phoneNumber",
        "items",
        "method",
        "lastFiveNumber",
        "bank_transfer",
        "bankname",
        "transferDate",
        "needPaper"
      ];

      await this.formMixin_submit(fields, "post", "report/user");
    }
  },
  watch: {
    transferDateMenu(val) {
      val &&
        setTimeout(() => (this.$refs.transferDatePicker.activePicker = "YEAR"));
    }
  }
};
</script>
